import React, { useEffect, useState } from "react";
import HeaderDetailComponent from "../components/HeaderDetailComponent";
import PopUpConfirm from "../components/popup/PopUpConfirm";
import { Button } from "react-bootstrap";
import PopUpOpen from "../components/popup/PopUpOpen";
import PopUpPromotion from "../components/popup/PopUpPromotion";
import {
  checkUnusedTicket,
  checkUnusedTicketCount,
  checkPromotionUnused,
  getRoom,
} from "../services/game.service";
import { useQuery } from "react-query";
import PopUpUseTicket from "../components/popup/PopUpUseTicket";
import { useNavigate } from "react-router-dom";
import HeaderBar from "../components/HeaderBar";

export default function BuyTicketPage() {
  const navigate = useNavigate();
  const [popup, setPopup] = useState<any>({ PopUpConfirm: false });
  const [showPromotion, setShowPromotion] = useState(false);
  const [isPromotionActive, setIsPromotionActive] = useState(false);
  // Dummy data for tickets
  // const totalTickets = 420;
  const totalTickets = 300;
  const [soldTickets, setSoldTickets] = useState<number[]>([]);
  const [selected, setSelected] = useState<number[]>([]);
  const [search, setSearch] = useState("");
  const [showAvailable, setShowAvailable] = useState(true);
  const [showSold, setShowSold] = useState(true);

  // Filter tickets
  const tickets = Array.from({ length: totalTickets }, (_, i) => i + 1);
  const filteredTickets = tickets.filter((num) => {
    if (search && !num.toString().padStart(3, "0").includes(search))
      return false;
    if (!showAvailable && !soldTickets.includes(num)) return false;
    if (!showSold && soldTickets.includes(num)) return false;
    return true;
  });

  const handleSelect = (num: number) => {
    if (soldTickets.includes(num)) return;
    setSelected((prev) =>
      prev.includes(num) ? prev.filter((n) => n !== num) : [...prev, num]
    );
  };

  const {
    data: roomData,
    isLoading,
    refetch,
  } = useQuery(["get-room-data"], async () => {
    // getRoom() will read token from sessionStorage if available
    return await getRoom();
  });
  React.useEffect(() => {
    if (roomData) {
      setSoldTickets(roomData?.ticketInactive?.lv1 || []);
    }
  }, [roomData]);

  const { refetch: refetchUnusedTickets } = useQuery(
    ["check-unused-tickets"],
    async () => {
      return await checkUnusedTicket({});
    },
    {
      onSuccess: (data) => {
        console.log("check-unused-tickets data:::", data);
        if (!!data) {
          if (data?.ticketLevel == "L1") {
            setPopup({ PopUpUseTicket: data?._id });
          } else {
            navigate("/game2/select/" + data?._id, { replace: true });
          }
        }
      },
    }
  );
  const { data: countData } = useQuery(
    ["check-unused-tickets-count"],
    async () => {
      return await checkUnusedTicketCount({});
    }
  );

  // Check promotion status via API
  useQuery(
    ["check-promotion-unused"],
    async () => {
      return await checkPromotionUnused({});
    },
    {
      onSuccess: (data) => {
        if (data?.isPromotionActive === true) {
          setShowPromotion(true);
          setIsPromotionActive(true);
        } else {
          setIsPromotionActive(false);
        }
      },
    }
  );

  return (
    <div>
      <div
        style={{
          height: "100dvh",
          minHeight: "100dvh",
          maxHeight: "100dvh",
          padding: 0,
          margin: 0,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        {/* <HeaderDetailComponent /> */}
        <HeaderBar onBack={() => navigate(-1)} />

        {/* Search Input */}
        <div className="pl-2 pr-2 pb-2 pt-2" style={{}}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              background: "rgba(255, 255, 255, 0.7)",
              padding: "8px 12px",
              borderRadius: 8,
            }}
          >
            <input
              type="text"
              placeholder="ຄົ້ນຫາເລກ(1-420)"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                flex: 1,
                padding: "8px 12px",
                borderRadius: 8,
                border: "none",
                fontSize: 16,
              }}
            />
            <button
              onClick={() => setSearch("")}
              style={{
                marginLeft: 8,
                background: "none",
                border: "none",
                fontSize: 20,
                color: "#D96B8A",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </div>
        </div>

        {/* Search & Filter */}
        <div
          style={{ height: "100%", overflow: "auto" }}
          hidden={isLoading}
          className="pl-2 pr-2"
        >
          {/* Card */}
          <div
            style={{
              padding: 10,
              background: "rgba(255, 255, 255, 0.7)",
              borderRadius: 8,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 16,
                }}
              >
                <label
                  onClick={() => setShowAvailable((v) => !v)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px solid #D65072",
                      boxSizing: "border-box",
                      background: "#fff",
                    }}
                  >
                    {showAvailable ? (
                      <div
                        style={{
                          width: 10,
                          height: 10,
                          background: "#D65072",
                          borderRadius: 2,
                        }}
                      />
                    ) : null}
                  </div>
                  <span style={{ fontSize: 14 }}>ວ່າງ</span>
                </label>

                <label
                  onClick={() => setShowSold((v) => !v)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px solid #D65072",
                      boxSizing: "border-box",
                      background: "#fff",
                    }}
                  >
                    {showSold ? (
                      <div
                        style={{
                          width: 10,
                          height: 10,
                          background: "#D65072",
                          borderRadius: 2,
                        }}
                      />
                    ) : null}
                  </div>
                  <span style={{ fontSize: 14 }}>ຂາຍແລ້ວ</span>
                </label>

                {/* <div style={{ marginLeft: "auto" }} /> */}
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ color: "#D96B8A", fontWeight: 700 }}>
                  ຈຳນວນບັດ
                </div>
                <div
                  style={{
                    // background: "#D65072",
                    // color: "#fff",
                    color: "#D96B8A",
                    padding: "6px 12px",
                    borderRadius: 20,
                    fontWeight: 700,
                    fontSize: 16,
                  }}
                >
                  {filteredTickets.length}/{totalTickets}
                </div>
              </div>
            </div>

            {/* Ticket Grid */}
            <div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(7, 1fr)",
                  gap: "8px 6px",
                  paddingTop: 16,
                }}
              >
                {filteredTickets.map((num, index) => {
                  const isSold = soldTickets.includes(num);
                  const isSelected = selected.includes(num);
                  return (
                    <div
                      style={{
                        aspectRatio: "2 / 1",
                        position: "relative",
                        zIndex: filteredTickets.length - index,
                      }}
                    >
                      <div
                        key={num}
                        onClick={() => {
                          if (!isSold) {
                            handleSelect(num);
                          }
                        }}
                        style={{
                          borderRadius: 8,
                          border: "none",
                          overflow: "hidden",
                          background: isSold
                            ? "#ccc"
                            : isSelected
                            ? "#D65072"
                            : "#fff",
                          color: isSold
                            ? "#888"
                            : isSelected
                            ? "#ffffff"
                            : "#333",
                          fontWeight: isSelected ? 700 : 400,
                          fontSize: 10,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          aspectRatio: "1 / 1",
                          position: "absolute",
                          left: 0,
                          right: 0,
                          bottom: 0,
                          cursor: isSold ? "not-allowed" : "pointer",
                          boxShadow: "1px 1px 5px rgba(0,0,0,0.2)",
                        }}
                      >
                        {num.toString().padStart(3, "0")}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="min-h-[50px] h-[50px]" />
        </div>

        {/* Bottom Panel */}
        <div
          hidden={isLoading}
          style={{
            // position: "absolute",
            // left: 0,
            // right: 0,
            // bottom: 0,
            background: "#ffffff",
            padding: "16px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderTop: "3px solid #D65072",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "50px 1fr auto",
              width: "100%",
              gap: 12,
            }}
          >
            <div
              style={{
                background: "#D96B8A",
                borderRadius: 4,
                overflow: "hidden",
                fontWeight: 700,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#ffffff",
                fontSize: 18,
                aspectRatio: "1 / 1",
              }}
            >
              000
            </div>
            <div style={{ textAlign: "start", flex: 1, marginLeft: 16 }}>
              <div style={{ color: "#D96B8A", fontWeight: 700, fontSize: 16 }}>
                {selected.length} ໃບ
              </div>
              <div style={{ fontSize: 14, color: "#333" }}>
                ເລືອກ : {selected.join(", ") || "-"}
              </div>
              <div style={{ fontSize: 14, color: "#333", fontWeight: 700 }}>
                ລວມທັງໝົດ : {selected?.length}{" "}
                <span style={{ color: "#7D4EDB" }}>💎</span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                flex: 1,
              }}
            >
              <Button
                style={{
                  background: "#D96B8A",
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  padding: "8px 12px",
                  fontWeight: 700,
                  fontSize: 14,
                  cursor: "pointer",
                }}
                disabled={
                  isPromotionActive
                    ? selected.length != 2
                    : selected.length === 0
                }
                onClick={() => {
                  setPopup({ PopUpConfirm: true });
                }}
              >
                {isPromotionActive ? "ຊື້ສະຫລາກ ຟຣີ 💎" : "ຊື້ສະຫລາກເລີຍ"}
              </Button>
            </div>
          </div>
        </div>

        {/* popup */}
        <PopUpConfirm
          open={popup.PopUpConfirm}
          data={selected}
          roomId={roomData?._id}
          onClose={() => {
            setSelected([]);
            refetch();
            setPopup({});
          }}
          onStartOpen={(data) => {
            setSelected([]);
            refetch();
            setPopup({ PopUpOpen: data?._id });
          }}
        />
        <PopUpOpen
          open={!!popup.PopUpOpen}
          billId={popup.PopUpOpen}
          onStartOpen={(ticketIds) => {
            const getTicketId = ticketIds.find(
              (t: any) => t.ticketLevel == "L1" && !t?.isUsed && !t?.isExpired
            );
            if (getTicketId) {
              setPopup({ PopUpUseTicket: getTicketId._id });
            } else {
              setPopup({ PopUpOpen: false });
            }
          }}
          onClose={() => {
            setPopup({ PopUpOpen: false });
          }}
        />
        <PopUpUseTicket
          open={!!popup.PopUpUseTicket}
          ticketId={popup.PopUpUseTicket}
          onClose={() => {
            refetchUnusedTickets();
            setPopup({ PopUpUseTicket: false });
          }}
          onStartOpen={(data) => {
            setPopup({ PopUpOpen: data?._id });
          }}
        />
        <PopUpPromotion
          open={showPromotion}
          onClose={() => setShowPromotion(false)}
          onAccept={() => setShowPromotion(false)}
        />
      </div>

      <div
        className="bg-primary h-[50px] w-[50px] rounded-full fixed top-[100px] left-[10px]"
        style={{
          zIndex: 10000,
          border: "4px solid #fff",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          color: "#fff",
          display: !!countData?.count || countData?.count > 0 ? "flex" : "none",
        }}
      >
        {countData?.count || 0}
      </div>
    </div>
  );
}
